/**
 * Deterministic RNG. Used so that demo mode (spine §4 "demo mode") and tests are
 * reproducible: the same seed produces the same sequence of operator choices and
 * selections. Never improvise in front of a jury.
 */
/** mulberry32 — small, fast, deterministic 32-bit PRNG. */
export function makeRng(seed) {
    let a = seed >>> 0;
    const next = () => {
        a |= 0;
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
    const int = (n) => Math.floor(next() * n);
    const pick = (arr) => {
        if (arr.length === 0)
            throw new Error('pick from empty array');
        return arr[int(arr.length)];
    };
    const weighted = (items, weights) => {
        if (items.length === 0)
            throw new Error('weighted pick from empty array');
        if (items.length !== weights.length) {
            throw new Error('items and weights length mismatch');
        }
        const total = weights.reduce((s, w) => s + Math.max(0, w), 0);
        if (total <= 0)
            return pick(items);
        let r = next() * total;
        for (let i = 0; i < items.length; i++) {
            r -= Math.max(0, weights[i]);
            if (r <= 0)
                return items[i];
        }
        return items[items.length - 1];
    };
    return { next, int, pick, weighted };
}
/** Derive a numeric seed from a string (e.g. a session id) for reproducibility. */
export function seedFromString(s) {
    let h = 2166136261 >>> 0;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
//# sourceMappingURL=rng.js.map